import { Button } from '@fluentui/react-components';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocalizationUnauthenticated } from '../Components/Helpers/useLocalization';

const NotFoundPage: React.FC = () => {
    const L = useLocalizationUnauthenticated();
    const nav = useNavigate();

    const goHome = () => {
        nav('/');
    }

    return (
        <div className='login-container'>
            <div className='login-box' style={{textAlign: 'center'}}>
                <h1>{L('localization_error_page_not_found_title')}</h1>
                <p>{L('localization_error_page_not_found_message')}</p>
                <Button appearance='primary' onClick={goHome}>{L('localization_common_go_home')}</Button>
            </div>
        </div>
    );
}

export default NotFoundPage;